import config from 'lib/config';
import { fetchGCPJson } from 'lib/utils/fetch';

export enum Action {
  PROFILE = 'profile',
  CALL = 'call',
  REVEAL_PHONE_NUMBER = 'reveal_phone_number',
  MESSAGE = 'message',
  LINK = 'link',
}

export enum MediaPlacementType {
  SEARCH_RESULT = 'SearchResult',
}

export type SearchType = 'Listings' | 'RequestAQuote';

export type PlacementType =
  | 'SearchResult'
  | 'SimilarTrades'
  | 'RequestAQuoteAfterDM';

export type DisplayAuctionOptions = {
  user: {
    id?: string;
    isAuthenticated?: boolean;
    userAgent?: string;
    ipAddress?: string;
  };
  targeting: {
    category: number;
    location: string;
  };
  maxSponsoredItems: number;
  eligibleCampaigns?: {
    id: string;
    score: number;
  }[];
  placementType: MediaPlacementType;
};

export type DisplayAuctionResult = {
  winners: {
    id: string;
    isInternal: boolean;
    companyId: string;
    campaignId: string;
    trackingId: string;
    targetUrl?: string | null;
    creatives: {
      id: number;
      callToAction?: string | null;
      headline?: string | null;
      body?: string | null;
      imageUrl?: string | null;
      brandImageUrl?: string | null;
    }[];
  }[];
};

/**
 * Rank refers to the rank of the sponsored trades compared to other sponsored trades, as we only request 1, rank for now will always be 0
 */

/**
 * Notify when trade is visible
 */
export const notifyImpression = async (
  trackingId: string,
  rank: number = 0,
) => {
  const url = `${config.adServerPublicApiUrl}/impression?rank=${rank}&trackingId=${trackingId}`;

  try {
    await fetchGCPJson(url);
  } catch (error) {}

  return;
};

/**
 * Notify click on trade
 */
export const notifyClick = async (
  action: Action,
  trackingId: string,
  rank: number = 0,
) => {
  const url = `${config.adServerPublicApiUrl}/click?rank=${rank}&trackingId=${trackingId}&action=${action}`;

  try {
    await fetchGCPJson(url);
  } catch (error) {}

  return;
};

/**
 * Get available options for display ad
 */
export const getDisplayAdWinners = async (
  options: DisplayAuctionOptions,
  signal?: AbortSignal,
): Promise<DisplayAuctionResult> => {
  const url = `${config.adServerPublicApiUrl}/sponsored-display`;

  const method = 'POST';
  const body = JSON.stringify(options);

  try {
    const result = await fetchGCPJson<DisplayAuctionResult>(url.toString(), {
      method,
      body,
      signal,
    });
    return result;
  } catch (error) {
    return { winners: [] };
  }
};

/**
 * Notify when display ad is visible
 */
export const notifyDisplayAdImpression = async (
  trackingId: string,
  rank: number = 0,
) => {
  const url = `${config.adServerPublicApiUrl}/display-impression?trackingId=${trackingId}&rank=${rank}`;

  try {
    await fetchGCPJson(url.toString());
  } catch (error) {}

  return;
};

/**
 * Notify click on display ad
 */
export const notifyDisplayAdClick = async (
  action: Action,
  trackingId: string,
  rank: number = 0,
) => {
  const url = `${config.adServerPublicApiUrl}/display-click?trackingId=${trackingId}&rank=${rank}&action=${action}`;

  try {
    await fetchGCPJson(url.toString());
  } catch (error) {}

  return;
};
